import React from "react"
import BackgroundImage from "gatsby-background-image"
import { StaticQuery, graphql, useStaticQuery } from "gatsby"
import Img from "gatsby-image"

import Layout from "../../../components/layout"
import style from "./index.module.css"
import AndvicHeader from "../../../components/andvic-header"
import BurgerMenu from "../../../components/burger-menu"

import Carousel, { Modal, ModalGateway, ViewType } from "react-images"
import SEO from "../../../components/seo"

export interface IAppProps {
  data: any
}

export interface IAppState {
  modalIsOpen: boolean
  selectedIndex?: number
}

class Gallery extends React.Component<IAppProps, IAppState> {
  constructor(props: IAppProps) {
    super(props)

    this.state = {
      modalIsOpen: false,
      selectedIndex: 0,
    }
  }

  toggleLightbox = (selectedIndex: number = 0) => {
    this.setState(state => ({
      modalIsOpen: !state.modalIsOpen,
      selectedIndex,
    }))
  }

  public render() {
    const { data } = this.props

    const images = data.galleryImages.edges.map((x: any) => ({
      source: x.node.childImageSharp.fluid.src,
      originalName: x.node.childImageSharp.fluid.originalName,
    }))

    const sortedImage = [...images].sort((a: any, b: any) =>
      a.originalName > b.originalName
        ? 1
        : b.originalName > a.originalName
        ? -1
        : 0
    )

    const { modalIsOpen, selectedIndex } = this.state

    return (
      <>
        <ModalGateway>
          {modalIsOpen ? (
            <Modal
              closeOnBackdropClick={true}
              closeOnEsc={true}
              onClose={_e => {
                this.toggleLightbox(0)
              }}
            >
              <Carousel
                currentIndex={selectedIndex}
                styles={{
                  footerCaption: (base, state) => ({
                    ...base,
                    display: "none",
                  }),
                  view: base => ({
                    ...base,
                    "& > img": {
                      margin: "auto",
                    },
                  }),
                }}
                views={sortedImage}
              />
            </Modal>
          ) : null}
        </ModalGateway>
        <div onClick={_e => this.toggleLightbox(0)}>
          <Img fluid={data.stairsSquare.childImageSharp.fluid} />
        </div>
        <div onClick={_e => this.toggleLightbox(1)}>
          <Img fluid={data.kitchenTwoSquare.childImageSharp.fluid} />
        </div>
        <div onClick={_e => this.toggleLightbox(2)}>
          <Img fluid={data.bathTwoSquare.childImageSharp.fluid} />
        </div>
        <div onClick={_e => this.toggleLightbox(3)}>
          <Img fluid={data.bedSquare.childImageSharp.fluid} />
        </div>
      </>
    )
  }
}

const BackgroundSection = ({
  className,
  data,
  header,
}: {
  className: any
  data: any
  header: any
}) => {
  const imageData = data.desktop.childImageSharp.fluid
  return (
    <>
      <BackgroundImage Tag="section" className={className} fluid={imageData}>
        <AndvicHeader></AndvicHeader>

        <h1 className={style.pageHeader}>
          <span>{header}</span>
        </h1>
      </BackgroundImage>
    </>
  )
}

export default function IndexPage(): JSX.Element {
  const data = useStaticQuery(graphql`
    query {
      desktop: file(relativePath: { eq: "bayview1/pool-2.jpg" }) {
        childImageSharp {
          fluid(quality: 80, maxWidth: 1920) {
            ...GatsbyImageSharpFluid_withWebp
            originalName
          }
        }
      }

      kitchenTwoSquare: file(name: { eq: "2-kitchen2" }) {
        childImageSharp {
          fluid(quality: 80, maxWidth: 296) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }

      bathTwoSquare: file(name: { eq: "3-bath" }) {
        childImageSharp {
          fluid(quality: 80, maxWidth: 296) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }

      bedSquare: file(name: { eq: "4-bed" }) {
        childImageSharp {
          fluid(quality: 80, maxWidth: 296) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }

      stairsSquare: file(name: { eq: "1-stairs" }) {
        childImageSharp {
          fluid(quality: 80, maxWidth: 296) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }

      galleryImages: allFile(
        filter: { relativeDirectory: { eq: "bayview1/gallery" } }
      ) {
        edges {
          node {
            relativePath
            relativeDirectory
            dir
            childImageSharp {
              fluid(quality: 80, maxWidth: 1920) {
                ...GatsbyImageSharpFluid
                originalName
              }
            }
          }
        }
      }

      portfolioOne: file(relativePath: { eq: "bayview1/kitchen.jpg" }) {
        childImageSharp {
          fluid(quality: 80, maxWidth: 1920) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
    }
  `)

  return (
    <Layout>
      <SEO title="Bayview - Portfolio" />
      <BurgerMenu></BurgerMenu>

      <BackgroundSection
        data={data}
        className={style.header}
        header={"Bayview"}
      ></BackgroundSection>

      {/* <div className={style.mainHeader}>
        <div className={style.mainHeaderCopy}>
          <div className={style.mainHeaderCopyLeft}>
            <div className={style.mainHeaderCopyLeftInner}>
              <h3 className={style.subMenuHeader}>Portfolio</h3>
              <div className={style.subMenu}>
                <h2>Bayview</h2>
              </div>
            </div>
          </div>
        </div>
      </div> */}

      <div className={style.portfolioMain}>
        <div>
          <h2 className={style.portfolioSubheader}>
            Luxury Living and Entertainment
          </h2>
          <p>
            Contemporary home set in Bayview Barkala Eco Estate with waterviews
            offering abundance of space, versatility and luxury. Designed by
            Andvic in conjunction with a Sydney award winning Architect to
            achieve an exceptional open plan design, modern clean lines and
            finishes of the highest standard.
          </p>
          <p>Key building features include</p>
          <ul className={style.bulletList}>
            <li>Designer staircase and feature wall to entry</li>
            <li>
              Grand open plan dining and living area overlooking swimming pool,
              spa and ocean views
            </li>
            <li>
              Luxurious kitchen with marble stone benchtops, soft close drawers
              and high-end appliances
            </li>
            <li>
              Superb master bedroom wing overlooks the pool with a deluxe
              walk-in wardrobe and spacious bathroom
            </li>
            <li>Underfloor heating to all areas</li>
          </ul>
        </div>
        <div className={style.home2}>
          <div>
            <Img fluid={data.portfolioOne.childImageSharp.fluid} />
          </div>
        </div>
      </div>
      <div className={style.portfolioGallery}>
        <Gallery data={data} />
      </div>
    </Layout>
  )
}
